import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Shipments from "@/pages/Shipments";
import NewShipment from "@/pages/NewShipment";
import ShipmentDetail from "@/pages/ShipmentDetail";
import Settings from "@/pages/Settings";
import PublicShipment from "@/pages/PublicShipment";
import MobilePunch from "@/pages/MobilePunch";
import WalkieScreen from "@/pages/WalkieScreen";
import PunchAdmin from "@/pages/PunchAdmin";
import NightlyReport from "@/pages/NightlyReport";
import Permits from "@/pages/Permits";
import Expenses from "@/pages/Expenses";
import TCAndTCSR from "@/pages/TCAndTCSR";
import PurchaseInv from "@/pages/PurchaseInv";
import PurchaseInv2 from "@/pages/PurchaseInv2";
import BankStatement from "@/pages/BankStatement";
import Quotation from "@/pages/Quotation";
import Others from "@/pages/Others";
import MobileExpenses from "@/pages/MobileExpenses";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/public/shipments/:token" element={<PublicShipment />} />
            <Route path="/punch" element={<ProtectedRoute><MobilePunch /></ProtectedRoute>} />
            <Route path="/walkie" element={<ProtectedRoute><WalkieScreen /></ProtectedRoute>} />
            <Route path="/punch-admin" element={<ProtectedRoute><PunchAdmin /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/shipments" element={<ProtectedRoute><Shipments /></ProtectedRoute>} />
            <Route path="/shipments/new" element={<ProtectedRoute><NewShipment /></ProtectedRoute>} />
            <Route path="/shipments/:id" element={<ProtectedRoute><ShipmentDetail /></ProtectedRoute>} />
            <Route path="/nightly-report" element={<ProtectedRoute><NightlyReport /></ProtectedRoute>} />
            <Route path="/permits" element={<ProtectedRoute><Permits /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
            <Route path="/tc-and-tcsr" element={<ProtectedRoute><TCAndTCSR /></ProtectedRoute>} />
            <Route path="/purchase-inv" element={<ProtectedRoute><PurchaseInv /></ProtectedRoute>} />
            <Route path="/purchase-inv-2" element={<ProtectedRoute><PurchaseInv2 /></ProtectedRoute>} />
            <Route path="/quotation" element={<ProtectedRoute><Quotation /></ProtectedRoute>} />
            <Route path="/bank-statement" element={<ProtectedRoute><BankStatement /></ProtectedRoute>} />
            <Route path="/others" element={<ProtectedRoute><Others /></ProtectedRoute>} />
            <Route path="/mobile-expenses" element={<ProtectedRoute><MobileExpenses /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
